import { render, staticRenderFns } from "./detail-form.vue?vue&type=template&id=38b25286&scoped=true"
import script from "./detail-form.vue?vue&type=script&lang=js"
export * from "./detail-form.vue?vue&type=script&lang=js"
import style0 from "./detail-form.vue?vue&type=style&index=0&id=38b25286&prod&lang=scss&scoped=true"
import style1 from "./detail-form.vue?vue&type=style&index=1&id=38b25286&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b25286",
  null
  
)

export default component.exports